import { render, staticRenderFns } from "./MainCategorySelect.vue?vue&type=template&id=4a90ae15&scoped=true&"
import script from "./MainCategorySelect.vue?vue&type=script&lang=js&"
export * from "./MainCategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./MainCategorySelect.vue?vue&type=style&index=0&id=4a90ae15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a90ae15",
  null
  
)

export default component.exports